import {
  FaMedal, FaCogs, FaShippingFast, FaHandshake,
  FaMicroscope, FaDollarSign,
} from 'react-icons/fa';
import SectionTitle from './ui/SectionTitle';
import FeatureCard from './ui/FeatureCard';
import './WhyChooseUs.css';

const REASONS = [
  { icon: <FaMedal />,        title: 'ISO Certified Quality',    desc: 'All instruments comply with ISO 9001, CE, and FDA standards ensuring reliability in critical medical environments.' },
  { icon: <FaMicroscope />,   title: 'Precision Manufacturing',  desc: 'CNC-machined components with micron-level tolerances. Each piece inspected before packaging.' },
  { icon: <FaCogs />,         title: 'Custom OEM Solutions',     desc: 'Private labeling and custom instrument design services. Your specifications, our expertise.' },
  { icon: <FaShippingFast />, title: 'Fast Global Shipping',     desc: 'Reliable logistics partners ensure your order reaches anywhere in the world on time, every time.' },
  { icon: <FaDollarSign />,   title: 'Factory-Direct Pricing',   desc: 'No middlemen. Get the best wholesale prices directly from our manufacturing facility.' },
  { icon: <FaHandshake />,    title: 'Dedicated Support',        desc: "A personal account manager for every client. From quotation to delivery — we're with you." },
];

export default function WhyChooseUs() {
  return (
    <section className="why-us" id="why-us">
      <div className="container">
        <SectionTitle
          title="Why Choose H.A Surgical?"
          subtitle="We don't just manufacture instruments — we build partnerships built on quality and trust"
        />

        <div className="why-us__grid">
          {REASONS.map(r => (
            <FeatureCard key={r.title} icon={r.icon} title={r.title} desc={r.desc} />
          ))}
        </div>
      </div>
    </section>
  );
}
